import { Directive, AfterViewInit, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[ccEnterKeyDown]'
})
export class EnterKeyDownDirective implements AfterViewInit {

// #region [ Fields ]

	/** The DOM element this directive is tied to. */
	private _Element: ElementRef;
	@Input() public KeyDownFunction: Function = null;

// #region [ Constructor ]

	constructor(Element: ElementRef) {
		this._Element = Element;
	}

// #region [ Implemented Methods ]

	/**
	 * After view initilized event.
	 */
	public ngAfterViewInit(): void {
		let objElement: HTMLElement;
		let objFunction: Function;

		objFunction = this.OnKeyDown.bind(this);
		objElement = this._Element.nativeElement;
		objElement.addEventListener("keydown", function (objEvent) { objFunction(objEvent) });
	}

// #region [ Event Handlers ]

	public OnKeyDown(Event: KeyboardEvent): void {
		if (Event.keyCode == 13)
			this.ExecuteKeyDown();
	}

// #region [ Private Methods ]

	private ExecuteKeyDown(): void {
		if (this.KeyDownFunction != null)
			this.KeyDownFunction();
	}

}